var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'app-container':!_vm.$route.query.linkIframe, 'no-bg df hp100': _vm.hasLeft }},[(_vm.$slots.left)?[_c('div',{staticClass:"left extend",style:(_vm.leftStyle)},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"center flex-one"},[_vm._t("default")],2)]:[_vm._t("default")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06dbcfee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/AppContainer/index.vue
// module id = null
// module chunks = 